import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./policyInsightsConflictAckPatchActions";

function* policyInsightsConflictAckPatch(action) {
  try {
    const { data } = yield call(
      requestWithSubTenantIfNeeded,
      "patch",
      `swg/conflicts/${action.id}/ack`
    );

    yield put(actions.requestSuccess(action.id, data));

    if (action.resolve) {
      yield call(action.resolve, data);
    }
  } catch (error) {
    yield put(actions.requestFailure(action.id, error));

    if (action.reject) {
      yield call(action.reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(
    actions.POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST,
    policyInsightsConflictAckPatch
  );
}

export default saga;
